import _ from 'lodash';
import moment from 'moment';
import { MyXLSX2 } from '@/utils/xlsxExport2';
import { monthOptions } from '@/assets/commonData/options';

let CD;

export default {
    created() {
        CD = moment().format('YYYY-MM-DD');
    },
    methods: {
        onExport() {
            const wb = MyXLSX2.createBook();
            this.isLoadingExport = true;

            try {
                const sumSheet = this.getSummarySheet(this.pageData.subTotals);

                if (sumSheet) MyXLSX2.bookAppendSheet(wb, sumSheet, '匯總');

                this.pageData.analysisGroups.forEach((child) => {
                    const sheet = this.getDetainSheet(child);
                    if (sheet) {
                        MyXLSX2.bookAppendSheet(wb, sheet, child.groupName);
                    }
                });

                MyXLSX2.download(wb, `營業支出分析${CD}`);
            } catch (e) {
                if (`${e}`.includes('empty')) {
                    this.$message({
                        showClose: true,
                        message: '無資料可匯出',
                        type: 'error',
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: `${e}`,
                        type: 'error',
                    });
                }
            } finally {
                this.isLoadingExport = false;
            }
        },
        getSummarySheet(details) {
            if (!details.length) return null;
            console.log(details);
            const monthlyInfos = this.getSummaryMonthlyInfo();

            const monthText = _.find(monthOptions, ['key', this.month])?.value;
            const title = monthText ? `營業支出分析 - 匯總 (${monthText}份)` : '營業支出分析 - 匯總';

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '', width: 5, align: 'center' },
                { text: '支出項目群組', width: 20, align: 'left' },
                { text: '一月', align: 'right', number: true },
                { text: '二月', align: 'right', number: true },
                { text: '三月', align: 'right', number: true },
                { text: '四月', align: 'right', number: true },
                { text: '五月', align: 'right', number: true },
                { text: '六月', align: 'right', number: true },
                { text: '七月', align: 'right', number: true },
                { text: '八月', align: 'right', number: true },
                { text: '九月', align: 'right', number: true },
                { text: '十月', align: 'right', number: true },
                { text: '十一月', align: 'right', number: true },
                { text: '十二月', align: 'right', number: true },
                { text: '含稅總額', align: 'right', number: true },
                { text: '%', align: 'center' },
            ];

            // 內容資料
            const bodyRows = [];
            const totalAmt = _.last(details).amount;
            const totalTax = _.last(details).tax;
            details.forEach((item) => {
                const ITEM = _.find(monthlyInfos, ['name', item.name]);
                console.log(ITEM);
                const row = [
                    '',
                    '',
                    item.name || '--',
                    ITEM?.monthlyInfos[0].value || '--',
                    ITEM?.monthlyInfos[1].value || '--',
                    ITEM?.monthlyInfos[2].value || '--',
                    ITEM?.monthlyInfos[3].value || '--',
                    ITEM?.monthlyInfos[4].value || '--',
                    ITEM?.monthlyInfos[5].value || '--',
                    ITEM?.monthlyInfos[6].value || '--',
                    ITEM?.monthlyInfos[7].value || '--',
                    ITEM?.monthlyInfos[8].value || '--',
                    ITEM?.monthlyInfos[9].value || '--',
                    ITEM?.monthlyInfos[10].value || '--',
                    ITEM?.monthlyInfos[11].value || '--',
                    item.amount || '--',
                    totalAmt ? Math.round((item.amount / totalAmt) * 1000) / 10 : '--',
                ];
                bodyRows.push(row);
            });

            // 表頭資訊
            const headRows = [
                { label: '含稅總額總計', value: totalAmt || '--' },
                { label: '營業稅總計', value: totalTax || '--' },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        getDetainSheet(data) {
            const details = _.chain(data.itemInfos)
                .map((o) => {
                    if (this.month > 0) {
                        const FOUND = _.find(o.monthlyInfos, ['month', this.month]);
                        return {
                            ...o,
                            amount: FOUND.amount,
                        };
                    }
                    return { ...o };
                })
                .value();

            if (!details.length) return null;

            const monthText = _.find(monthOptions, ['key', this.month])?.value;
            const title = monthText ? `營業支出分析 - ${data.groupName} (${monthText}份)` : `營業支出分析 - ${data.groupName}`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '', width: 5, align: 'center' },
                { text: '子項目', width: 20, align: 'left' },
                { text: '一月', align: 'right', number: true },
                { text: '二月', align: 'right', number: true },
                { text: '三月', align: 'right', number: true },
                { text: '四月', align: 'right', number: true },
                { text: '五月', align: 'right', number: true },
                { text: '六月', align: 'right', number: true },
                { text: '七月', align: 'right', number: true },
                { text: '八月', align: 'right', number: true },
                { text: '九月', align: 'right', number: true },
                { text: '十月', align: 'right', number: true },
                { text: '十一月', align: 'right', number: true },
                { text: '十二月', align: 'right', number: true },
                { text: '帳款總計', align: 'right', number: true },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    '',
                    '',
                    item.itemName,
                    item.monthlyInfos[0].amount || '--',
                    item.monthlyInfos[1].amount || '--',
                    item.monthlyInfos[2].amount || '--',
                    item.monthlyInfos[3].amount || '--',
                    item.monthlyInfos[4].amount || '--',
                    item.monthlyInfos[5].amount || '--',
                    item.monthlyInfos[6].amount || '--',
                    item.monthlyInfos[7].amount || '--',
                    item.monthlyInfos[8].amount || '--',
                    item.monthlyInfos[9].amount || '--',
                    item.monthlyInfos[10].amount || '--',
                    item.monthlyInfos[11].amount || '--',
                    item.amount || '--',
                ];
                bodyRows.push(row);
            });
            bodyRows.push([
                '',
                '',
                '合計',
                Math.round(_.sumBy(bodyRows, (o) => (typeof o[3] === 'number' ? o[3] : 0))) || '--',
                Math.round(_.sumBy(bodyRows, (o) => (typeof o[4] === 'number' ? o[4] : 0))) || '--',
                Math.round(_.sumBy(bodyRows, (o) => (typeof o[5] === 'number' ? o[5] : 0))) || '--',
                Math.round(_.sumBy(bodyRows, (o) => (typeof o[6] === 'number' ? o[6] : 0))) || '--',
                Math.round(_.sumBy(bodyRows, (o) => (typeof o[7] === 'number' ? o[7] : 0))) || '--',
                Math.round(_.sumBy(bodyRows, (o) => (typeof o[8] === 'number' ? o[8] : 0))) || '--',
                Math.round(_.sumBy(bodyRows, (o) => (typeof o[9] === 'number' ? o[9] : 0))) || '--',
                Math.round(_.sumBy(bodyRows, (o) => (typeof o[10] === 'number' ? o[10] : 0))) || '--',
                Math.round(_.sumBy(bodyRows, (o) => (typeof o[11] === 'number' ? o[11] : 0))) || '--',
                Math.round(_.sumBy(bodyRows, (o) => (typeof o[12] === 'number' ? o[12] : 0))) || '--',
                Math.round(_.sumBy(bodyRows, (o) => (typeof o[13] === 'number' ? o[13] : 0))) || '--',
                Math.round(_.sumBy(bodyRows, (o) => (typeof o[14] === 'number' ? o[14] : 0))) || '--',
                Math.round(_.sumBy(bodyRows, (o) => (typeof o[15] === 'number' ? o[15] : 0))) || '--',
            ]);

            const isZeroBodyRow = _.chain(bodyRows)
                .flatMap()
                .filter((o) => _.isNumber(o))
                .sum()
                .value() === 0;
            if (isZeroBodyRow) return undefined;

            const amount = _.sumBy(details, 'amount') || '--';
            // 表頭資訊
            const headRows = [
                { label: '未稅總額總計', value: amount },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },

        getSummaryMonthlyInfo() {
            if (!this.pageData.analysisGroups) return [];

            const series = [];
            const summaryMonthlyInfo = [];
            // init
            for (let m = 0; m < 12; m += 1) {
                summaryMonthlyInfo.push({ value: 0, month: m });
            }

            this.pageData.analysisGroups.forEach((g) => {
                const gDatas = [];
                // init
                for (let m = 0; m < 12; m += 1) {
                    gDatas.push({ value: 0, month: m });
                }

                // 每個子項目
                g.itemInfos.forEach((item) => {
                    // 每個月
                    gDatas.forEach((mObj, m) => {
                        if (item.monthlyInfos[m]) {
                            gDatas[m].value += Math.round(item.monthlyInfos[m].amount);
                            summaryMonthlyInfo[m].value += Math.round(item.monthlyInfos[m].amount);
                        }
                    });
                });

                series.push({ name: g.groupName, monthlyInfos: gDatas });
            });

            series.push({ name: '合計', monthlyInfos: summaryMonthlyInfo });

            return series;
        },
    },
};
